
<script setup lang="ts">
import useGlobalStore from '@/stores/modules/global'
import { TOAST_NOTIFICATION_ICONS } from '@/utils/constants/ui-constants'
import { BaseToastNotification } from '@/components/base'

const globalStore = useGlobalStore()
const getNotificationIcon = (type: string) => {
  return Object.entries(TOAST_NOTIFICATION_ICONS).find(([key, value]) => key === type)?.[1]
}
const handleContentClick = (callback: any) => {
  if (callback)
    callback()
};
</script>

<template>
  <div class="toast-notifications d-flex flex-column-reverse">
    <BaseToastNotification
      v-for="(notification, index) in globalStore.toastNotifications"
      v-bind="notification"
      :key="notification.id"
      :callback="notification.callback"
      :index="index"
      :class="notification.callback ? 'cursor-pointer' : ''"
    >
      <v-icon v-if="notification.type">
        {{ getNotificationIcon(notification.type) }}
      </v-icon>
      <div @click="handleContentClick(notification.callback)" class="ml-3 d-flex flex-column pr-3">
        <h5 v-if="notification.title">
          {{ notification.title }}
        </h5>
        <p v-if="notification.message" class="mb-0 body-1">
          {{ notification.message }}
        </p>
      </div>
    </BaseToastNotification>
  </div>
</template>

<style lang="scss" scoped>
.toast-notifications {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;
  margin-right: 32px;
  margin-top: 96px;
}
</style>
